/**
 * Controller: ProgramsInstanceEditRemoveModal
 */
angular.module('acme.view.application.programs.instance.edit.removeModal.controllers', [])
.controller('ProgramsInstanceEditRemoveModalController', [ '$scope', '$uibModalInstance', 'currentEvent', 'SoldQuantity', 'emailSetting', function ($scope, $uibModalInstance, currentEvent, SoldQuantity, emailSetting) {

    $scope.programsInstanceEditRemoveModal = {

      errors: [],

      model: {},

      notificationEmail: true,
      notificationType: 'always',
      notificationList: [],

      init: function() {
        this.model = currentEvent;
        this.setNotificationList();
        this.notificationType = emailSetting;
      },

      setNotificationList: function() {
        if (this.model.hasOwnProperty('resources')) {
          angular.forEach(this.model.resources, function(item, index) {
            if (item.resourceCategory === 'Personnel' &&
                item.resourceName &&
                item.resourceName.length) {
              $scope.programsInstanceEditRemoveModal.notificationList.push(item.resourceName);
            }
          });
        } else if (this.model.hasOwnProperty('requestSummary')){
          this.notificationList = this.model.requestSummary.people.resourceNames;
        }
      },

      checkNotification: function() {
        if (this.notificationType === 'never') {
          this.notificationEmail = false;
        }
      },

      hasErrors: function() {
        return (this.errors.length > 0);
      },

      hasSold: function() {
        return (SoldQuantity && SoldQuantity > 0);
      },

      done: function() {
        this.success();
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      success: function () {
        this.checkNotification();
        $uibModalInstance.close(this.notificationEmail);
      }
    };

    $scope.programsInstanceEditRemoveModal.init();

  }]);